import AlphaHelpers from './alpha-helpers'
import Logger from '@nematis/js-snippets/assets/js/logging/debug-logger'

export default class AlphaEventDispatcher {
  dispatchEvent(eventName, detail = {}, targetEl = null) {
    if (!targetEl) {
      targetEl = document
    }

    // dispatch custom event through default system
    const formattedEventName = this.getFormattedEventName(eventName)
    detail.emitter = this
    targetEl.dispatchEvent(new CustomEvent(formattedEventName, {
      detail
    }))

    // also dispatch event through our custom system
    let value = null
    const manager = this._getManager()
    if (manager) {
      detail.eventName = eventName
      detail.targetEl = targetEl

      // use event listener as an apply filters if a value to filter is passed
      const result = manager.dispatchModuleEvent(this._getModuleName(), eventName, detail)
      if (typeof detail.value !== 'undefined') {
        value = result || detail.value
      }
    }

    // add debug log
    Logger.debug('Dispatching event', formattedEventName)
    Logger.debug('event.detail', detail)
    Logger.debug('targetEl', targetEl)
    Logger.debug('value', value)

    return value
  }

  getFormattedEventName(eventName) {
    return `${this.getEventPrefix()}.${eventName}`
  }

  getEventPrefix() {
    const parts = ['alpha']
    if (this._isModule()) {
      parts.push(...['module', this.getName()])
    }

    return parts.join('.')
  }

  _isModule() {
    return typeof this.isDefaultModule === 'function'
  }

  _getManager() {
    if (!this._isModule()) {
      return this
    }

    if (AlphaHelpers.objectHasOwnProperty(window, 'alpha')) {
      return window.alpha
    }

    return null
  }

  _getModuleName() {
    return this._isModule() ? this.getName() : 'alpha'
  }
}
